<template>
    <div>
        <div v-if="showSearchBox">
            <div class="anchor">
                <div class="background" @click="resetSearchResults()"></div>
                <div class="container">
                    <div class="content">
                        <div class="columns">
                            <div class="column">
                                <div class="header">
                                    <span>{{l10nGemara}}</span>
                                </div>
                                <div class="body">
                                    <div v-if="areResultsLoading">
                                        <div class="loading">
                                            <span>...</span>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div v-if="didResultsFailToLoad">
                                            <div class="results-failed">
                                                <span>{{l10nSearchErrorText}}</span>
                                            </div>
                                        </div>
                                        <div v-else>
                                            <div v-if="areResultsEmptyContentTypeLesson">
                                                <div class="empty-results">
                                                    <span>{{l10nSearchEmptyResultsText}}</span>
                                                </div>
                                            </div>
                                            <div v-else>
                                                <div v-for="entry in entriesContentTypeLesson">
                                                    <div class="entry" @click="onEntryClick(entry)">
                                                        <span class="text">{{entry.displayName}}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="column">
                                <div class="header">
                                    <span>{{l10nMasechtot}}</span>
                                </div>
                                <div class="body">
                                    <div v-if="areResultsLoading">
                                        <div class="loading">
                                            <span>...</span>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div v-if="didResultsFailToLoad">
                                            <div class="results-failed">
                                                <span>{{l10nSearchErrorText}}</span>
                                            </div>
                                        </div>
                                        <div v-else>
                                            <div v-if="areResultsEmptyContentTypeLesson">
                                                <div class="empty-results">
                                                    <span>{{l10nSearchEmptyResultsText}}</span>
                                                </div>
                                            </div>
                                            <div v-else>
                                                <div v-for="entry in entriesContentTypeMasechet">
                                                    <div class="entry" @click="onEntryClick(entry)">
                                                        <span class="text">{{entry.displayName}}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import helpers from '../../services/helpers'
    import {
        LOADING_COMPLETED_FAILURE,
        LOADING_PRISTINE, LOADING_STARTED,
        SET_SEARCH_RESULTS_CONTENT_TYPE_LESSON,
        SET_SEARCH_RESULTS_CONTENT_TYPE_MASECHET,
    } from '../../services/constants'

    export default {
        name: 'jabra-search-results',
        data: function () {
            return {}
        },
        computed: {
            searchStoreModule() {
                return this.$store.state.searchModule
            },
            entriesContentTypeLesson() {
                return this.searchStoreModule.entriesContentTypeLesson.data
            },
            loadingStateContentTypeLesson() {
                return this.searchStoreModule.entriesContentTypeLesson.state
            },
            entriesContentTypeMasechet() {
                return this.searchStoreModule.entriesContentTypeMasechet.data
            },
            loadingStateContentTypeMasechet() {
                return this.searchStoreModule.entriesContentTypeMasechet.state
            },
            l10nGemara() {
                return this.l10nGetter('gemara').toUpperCase()
            },
            l10nMasechtot() {
                return this.l10nGetter('masechtot').toUpperCase()
            },
            l10nSearchErrorText() {
                return this.l10nGetter('error_searching_try_again_later')
            },
            l10nSearchEmptyResultsText() {
                return this.l10nGetter('search_no_results_found_try_expanding_your_search')
            },
            showSearchBox() {
                return this.loadingStateContentTypeLesson !== LOADING_PRISTINE
                    || this.loadingStateContentTypeMasechet !== LOADING_PRISTINE
            },
            areResultsLoading() {
                return this.loadingStateContentTypeLesson === LOADING_STARTED
                    || this.loadingStateContentTypeMasechet === LOADING_STARTED
            },
            didResultsFailToLoad() {
                return this.loadingStateContentTypeLesson === LOADING_COMPLETED_FAILURE
                    || this.loadingStateContentTypeMasechet === LOADING_COMPLETED_FAILURE
            },
            areResultsEmptyContentTypeLesson() {
                return this.entriesContentTypeLesson.length === 0
                    && this.entriesContentTypeMasechet.length === 0
            },
        },
        methods: {
            l10nGetter(key) {
                return helpers.uiTextGetter(this.$store, key)
            },
            onEntryClick(entry) {
                this.resetSearchResults()
                this.$router.push({
                    name: entry.contentType === 'masechet' ? 'subcategory' : 'lesson',
                    params: {
                        id: entry.entryID
                    }
                })

            },
            resetSearchResults() {
                this.$store.commit(SET_SEARCH_RESULTS_CONTENT_TYPE_LESSON, {
                    state: LOADING_PRISTINE,
                    data: [],
                    error: null,
                })
                this.$store.commit(SET_SEARCH_RESULTS_CONTENT_TYPE_MASECHET, {
                    state: LOADING_PRISTINE,
                    data: [],
                    error: null,
                })
            },
        },
    }
</script>

<style scoped lang="scss">
    @import "../../scss/main";

    .anchor {
        position: relative;
    }

    .background {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 2;
    }

    .container {
        position: absolute;
        z-index: 2;
    }

    .content {
        max-height: 500px;
        overflow-y: scroll;
        background-color: #ffffff;
        @include font-abraham(16px, $grey-1, 300);
        border: solid 1px $grey-2;
        padding: 20px 30px;
        min-width: 300px;
        line-height: 20px;
    }

    .columns {
        display: flex;
    }

    .column {
        width: 50%;
        margin: 0 10px;
    }

    .header {
        @include font-abraham(18px, $font-color-blue, 400);
        padding: 5px 0;
        border-bottom: solid 1px $grey-3;

    }

    .loading, .results-failed, .empty-results {
        margin: 5px 0;
    }

    .entry {
        margin: 10px 0;
        cursor: pointer;

        &:hover {
            .text {
                text-decoration: underline;
            }
        }
    }

</style>
